import { AxiosCall } from "../utils/axios.util";
import env from  '../environments';

export async function uploadResume(payload) {
 return AxiosCall.post(`${env.baseUrl}/${env.v1}/resume`, payload) 
}
